// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/search-results-main-display-item/search-results-main-display-item.component.scss
// module id = 682
// module chunks = 0